import React, { useState } from 'react';

import ColumnLayout from '../layouts/ColumnLayout';
import OrderTableComponent from '../components/OrderTableComponent';

export default function Trash() {
  const [reloadRows, setReloadRows] = useState(true);

  return (
    // TODO - Handle Orders here that were either delivered or removed from the inbox/home screen.
    <div>
      <ColumnLayout childs={[
        (<h1>Papelera</h1>),
        (<h3>Ordenes Judiciales Policiales</h3>),
        (<OrderTableComponent reloadRows={reloadRows} onSetReloadRows={setReloadRows} filter={'archives'}/>),
        // TODO: Use the nested GRID please findout an easy way to send it through props...
      ]} />
    </div>
  );
}
